goog.provide('el8.ext.onboarding.displayMgr');

goog.require('el8.template.ext.onboarding');
goog.require('el8.uiwidget.FormGuide');
goog.require('el8.ext.onboarding.identityForm');
goog.require('el8.ext.onboarding.dataAuthForm');
goog.require('el8.ext.onboarding.accountForm');
goog.require('el8.ext.onboarding.signupData');

el8.ext.onboarding.displayMgr = (function() {

    return {

        init: function() {

            var container = $('#form-onboarding');
            container.html(
                el8.template.ext.onboarding.pageSkeleton()
            ).removeClass('dataLoading');

            this._forms = {};

            this._formGuide = (new el8.uiwidget.FormGuide({
                start: 'identity',
                navContainer: $('.form-guide-nav-list', container),
                formContainer: $('.form-guide-container-list', container),
                errorContentFn: function() {
                    return el8.template.ext.onboarding.errorContent({
                        supportEmail: el8Globals['SUPPORT_EMAIL'],
                        supportPhone: el8Globals['SUPPORT_PHONE']
                    });
                }
            })).init();

            this._formGuide.registerForm({
                tagline: '1. Select Your Profile',
                name: 'identity',
                createFormFn: function(_formGuide, _container) {
                    return el8.ext.onboarding.identityForm.init({
                        name: 'identity',
                        container: _container,
                        formGuide: _formGuide
                    });
                }
            });

            this._formGuide.registerForm({
                tagline: '2. Authorize Us',
                name: 'auth',
                createFormFn: function(_formGuide, _container) {
                    return el8.ext.onboarding.dataAuthForm.init({
                        name: 'auth',
                        container: _container,
                        formGuide: _formGuide
                    });
                }
            });

            this._formGuide.registerForm({
                tagline: '3. Create Your Account',
                name: 'account',
                createFormFn: function(_formGuide, _container) {
                    return el8.ext.onboarding.accountForm.init({
                        name: 'account',
                        container: _container,
                        formGuide: _formGuide
                    });
                }
            });

            this._formGuide.start();

            var that = this;
            window.onpopstate = function(event) {
                if (event.state && event.state['name']) {
                    that._formGuide.historyShow(event.state['name']);
                }
            };

            _gaq.push(['_trackPageview', el8Globals['OB']+'signup/start/']);

        }

    };

})();


